import { SearchSuggestionsPayload } from 'store/providerSearch/search/types';
import { RootDispatch } from 'store/types';
import { providerSpecialties } from 'store/providerSearch/facets/actions';
import {
  PROVIDER_SUGGESTIONS,
  providerSuggestions
} from 'store/providerSearch/providerSuggestions/actions';
import { cancelActionRequest } from 'store/networkMiddleware/cancellationMiddleware';

export const searchSuggestions = ({ input }: SearchSuggestionsPayload) => (
  dispatch: RootDispatch
) => {
  dispatch(providerSpecialties({ input }));
  dispatch(providerSuggestions({ input }));
};

export const cancelSearchSuggestions = () => (dispatch: RootDispatch) => {
  dispatch(cancelActionRequest(PROVIDER_SUGGESTIONS));
};
